import { PlannerPurseCurrencySchema } from "./contracts.js";
const MAX_PERSISTED_MINOR_UNITS = 9223372036854775807n;
const PURSE_AMOUNT_PATTERN = /^(\d+)(?:\.(\d{1,3}))?$/u;
const PURSE_MINOR_PATTERN = /^\d{1,19}$/u;
const ZERO_MINOR_UNIT_CURRENCIES = new Set([
    "BIF",
    "CLP",
    "DJF",
    "GNF",
    "ISK",
    "JPY",
    "KMF",
    "KRW",
    "PYG",
    "RWF",
    "UGX",
    "VND",
    "VUV",
    "XAF",
    "XOF",
    "XPF",
]);
const THREE_MINOR_UNIT_CURRENCIES = new Set([
    "BHD",
    "IQD",
    "JOD",
    "KWD",
    "LYD",
    "OMR",
    "TND",
]);
export function plannerCurrencyMinorUnitDigits(currency) {
    const parsed = PlannerPurseCurrencySchema.safeParse(currency);
    if (parsed.success === false)
        return null;
    if (ZERO_MINOR_UNIT_CURRENCIES.has(parsed.data))
        return 0;
    if (THREE_MINOR_UNIT_CURRENCIES.has(parsed.data))
        return 3;
    return 2;
}
export function plannerPurseAmountToMinor(amount, currency) {
    const minorUnitDigits = plannerCurrencyMinorUnitDigits(currency);
    if (minorUnitDigits === null)
        return null;
    const match = PURSE_AMOUNT_PATTERN.exec(amount.trim());
    if (match?.[1] === undefined)
        return null;
    const whole = match[1].replace(/^0+(?=\d)/u, "");
    if (whole.length > 19)
        return null;
    const fraction = match[2];
    if ((minorUnitDigits === 0 && fraction !== undefined) ||
        (fraction?.length ?? 0) > minorUnitDigits) {
        return null;
    }
    const scale = 10n ** BigInt(minorUnitDigits);
    const paddedFraction = (fraction ?? "").padEnd(minorUnitDigits, "0");
    const minor = BigInt(whole) * scale +
        (paddedFraction.length === 0 ? 0n : BigInt(paddedFraction));
    return minor <= MAX_PERSISTED_MINOR_UNITS ? minor.toString() : null;
}
export function plannerPurseMinorToAmount(purseMinor, currency) {
    const minorUnitDigits = plannerCurrencyMinorUnitDigits(currency);
    if (minorUnitDigits === null ||
        PURSE_MINOR_PATTERN.test(purseMinor) === false) {
        return null;
    }
    const minor = BigInt(purseMinor);
    if (minor > MAX_PERSISTED_MINOR_UNITS)
        return null;
    if (minorUnitDigits === 0)
        return minor.toString();
    const scale = 10n ** BigInt(minorUnitDigits);
    const whole = minor / scale;
    const fraction = (minor % scale).toString().padStart(minorUnitDigits, "0");
    return `${whole}.${fraction}`;
}
